module.exports = __webpack_public_path__ + "clock-1f0fa209.svg";